import React, { Component } from 'react'
import { fabric } from 'fabric'
import { connect } from 'react-redux'
import { Loader } from '@components/UI'
import Actions from '@actions'

class Sketch extends Component {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  componentDidMount() {
    if (this.props.file.id) this.load()
    else this.init(this.props.file.data, this.props.file.metadata)
    window.addEventListener('resize', this.resize)
  }

  load = () =>
    this.setState({ loading: true }, () => {
      const stop = () => this.setState({ loading: false })

      this.props.loadFile(
        (file) => {
          this.init(
            { version: '4.2.0', objects: Object.values(file.data) },
            file.metadata
          )
          stop()
        },
        stop,
        this.props.file.id
      )
    })

  componentWillUnmount() {
    const { resize } = this
    window.removeEventListener('resize', resize)
  }

  resize = () => {
    const { canvas } = this
    if (!canvas) return
    canvas.setWidth(this._wrapper.offsetWidth)
    canvas.setHeight(this._wrapper.offsetHeight)
  }

  wheel = (opt) => {
    const delta = opt.e.deltaY
    let zoom = this.canvas.getZoom() + delta / 200
    zoom = zoom > 20 ? 20 : zoom < 0.1 ? 0.1 : zoom
    this.canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom)
    opt.e.preventDefault()
    opt.e.stopPropagation()
  }

  pinch = (evt) => {
    if (!this.pinchStartScale) this.pinchStartScale = this.canvas.getZoom()
    if (evt.touches && evt.touches.length === 2) {
      const delta = this.pinchStartScale * evt.scale
      this.canvas.zoomToPoint({ x: evt.layerX, y: evt.layerY }, delta)
    }
  }

  down = (opt) => {
    const evt = opt.e
    const TouchEvent = Object.prototype.hasOwnProperty.call(
      window,
      'TouchEvent'
    )
      ? window.TouchEvent
      : undefined
    if (TouchEvent && evt instanceof TouchEvent && evt.touches.length === 2) {
      this.canvas.set({
        isPinching: true,
        selection: false
      })
      return
    }

    this.canvas.set({
      isDragging: true,
      selection: false,
      lastPosX:
        TouchEvent && evt instanceof TouchEvent ? evt.layerX : evt.clientX,
      lastPosY:
        TouchEvent && evt instanceof TouchEvent ? evt.layerY : evt.clientY
    })
    this.canvas.setCursor('grabbing')
  }

  move = (opt) => {
    const evt = opt.e
    const TouchEvent = Object.prototype.hasOwnProperty.call(
      window,
      'TouchEvent'
    )
      ? window.TouchEvent
      : undefined
    if (
      this.canvas.isPinching ||
      (TouchEvent && evt instanceof TouchEvent && evt.touches.length === 2)
    ) {
      if (!this.canvas.isPinching) {
        this.canvas.set({
          isPinching: true,
          isDragging: false
        })
      }
      if (evt.touches.length === 2) this.pinch(evt)
      return
    }

    if (!this.canvas.isDragging) return
    const clientX =
      TouchEvent && evt instanceof TouchEvent ? evt.layerX : evt.clientX
    const clientY =
      TouchEvent && evt instanceof TouchEvent ? evt.layerY : evt.clientY
    this.canvas
      .set({
        viewportTransform: this.canvas.viewportTransform.map((v, i) =>
          i === 4
            ? v + clientX - this.canvas.lastPosX
            : i === 5
            ? v + clientY - this.canvas.lastPosY
            : v
        ),
        lastPosX: clientX,
        lastPosY: clientY
      })
      .requestRenderAll()
  }

  up = () => {
    if (this.canvas.isPinching) {
      this.pinchStartScale = undefined
      this.canvas.set({ isPinching: false })
      return
    }

    this.canvas
      .set({ isDragging: false, selection: true })
      .forEachObject((obj) => obj.setCoords())
  }

  init = (data, metadata = {}) => {
    this.canvas = new fabric.Canvas(this._container, {
      width: this._wrapper.offsetWidth,
      height: this._wrapper.offsetHeight,
      defaultCursor: 'grab',
      hoverCursor: 'grab'
    })
      // .on('mouse:wheel', this.wheel)
      .on('mouse:down', this.down)
      .on('mouse:move', this.move)
      .on('mouse:up', this.up)

    this.canvas.selection = false

    this.loadSnapshot(data, metadata)
  }

  loadSnapshot = (snapshot, config = {}) => {
    const { canvas } = this
    canvas.loadFromJSON(snapshot, () => {
      canvas.forEachObject((obj) => (obj.selectable = false))
      canvas.set(config)
      canvas.requestRenderAll()

      if (config.viewportTransform) {
        canvas.zoomToPoint(
          { x: config.viewportTransform[4], y: config.viewportTransform[5] },
          config.zoom
        )
      }
    })
  }

  render() {
    const { className = '', light } = this.props

    return (
      <div
        ref={(elem) => (this._wrapper = elem)}
        className={`sketch-block ${className} ${light ? 'light' : ''}`}
      >
        <canvas ref={(elem) => (this._container = elem)} />
        {this.state.loading && <Loader full icon />}
      </div>
    )
  }
}

const mapActionsToProps = {
  loadFile: Actions.loadFile
}

export default connect(() => ({}), mapActionsToProps)(Sketch)
